import { createContext } from 'react';

import { PolicyResponse } from '@src/@types/policies';

export const PolicyContext = createContext<PolicyResponse>(null);
